import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      errorMessage: '',
      successMessage: ''
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
      errorMessage: '',
      successMessage: ''
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const { email, password } = this.state;

    if (!email || !password) {
      this.setState({ errorMessage: 'All inputs are required!' });
      return;
    }

    try {
      const response = await fetch('/loginx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
          password
        })
      });

      const data = await response.json();

      if (response.status === 200) {
        // clear old data
        localStorage.removeItem('email');
        localStorage.removeItem('balance');
        localStorage.removeItem('userId');
        localStorage.removeItem('bio_slug');
        localStorage.removeItem('bio_url');
        localStorage.removeItem('bioToken');

        // store new user data
        localStorage.setItem('email', data.user.email);
        localStorage.setItem('userId', data.user.id);
        localStorage.setItem('bio_slug', data.user.bio_slug);
        localStorage.setItem('bio_url', data.user.bio_url);

        if (data.bioToken) {
          localStorage.setItem('bioToken', data.bioToken);
        }

        if (data.user.balance !== undefined) {
          localStorage.setItem('balance', String(data.user.balance));
        }

        this.setState({
          successMessage: 'Login successful! Redirecting...',
          errorMessage: ''
        });

        setTimeout(() => {
          // 🔥 FIX: clean redirect URL (remove domain if exists)
          let cleanRedirectUrl = data.redirectUrl;

          if (cleanRedirectUrl.startsWith('http')) {
            try {
              const parsed = new URL(cleanRedirectUrl);
              cleanRedirectUrl = parsed.pathname;
            } catch (e) {
              console.error('Invalid URL:', cleanRedirectUrl);
              cleanRedirectUrl = '/';
            }
          }

          this.props.history.push(cleanRedirectUrl);
        }, 1500);

      } else {
        this.setState({
          errorMessage: data.message || 'Invalid Credentials!',
          successMessage: ''
        });
      }

    } catch (error) {
      console.error(error);

      this.setState({
        errorMessage: 'An error occurred!',
        successMessage: ''
      });
    }
  };

  render() {
    const linkStyle = {
      color: '#007bff',
      textDecoration: 'none',
      fontSize: '0.9rem'
    };

    return (
      <div className="login-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className="logo" src={logo} alt="Logo" />

          <br />

          <div>
            <Link to="/">Home</Link>
          </div>

          <br />

          <div>Please proceed to login...</div>

          <br />

          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">

                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="email">Email</label>

                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        value={this.state.email}
                        onChange={this.handleInputChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="password">Password</label>

                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        id="password"
                        value={this.state.password}
                        onChange={this.handleInputChange}
                        required
                      />
                    </div>

                    {this.state.errorMessage && (
                      <div className="alert alert-danger mt-2">
                        {this.state.errorMessage}
                      </div>
                    )}

                    {this.state.successMessage && (
                      <div className="alert alert-success mt-2">
                        {this.state.successMessage}
                      </div>
                    )}

                    <button type="submit" className="btn btn-dark mt-3">
                      Login
                    </button>
                  </form>

                  <div style={{ marginTop: '12px' }}>
                    <Link to="/forgetpassword" style={linkStyle}>
                      Forgot password?
                    </Link>
                  </div>

                  <div className="mt-3">Powered by</div>

                  <img className="logo2" src={logo2} alt="Logo 2" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);
